import { render, staticRenderFns } from "./CustomScroll.vue?vue&type=template&id=0d0ab7e0&scoped=true"
import script from "./CustomScroll.vue?vue&type=script&lang=ts"
export * from "./CustomScroll.vue?vue&type=script&lang=ts"
import style0 from "./CustomScroll.vue?vue&type=style&index=0&id=0d0ab7e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0ab7e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0ab7e0')) {
      api.createRecord('0d0ab7e0', component.options)
    } else {
      api.reload('0d0ab7e0', component.options)
    }
    module.hot.accept("./CustomScroll.vue?vue&type=template&id=0d0ab7e0&scoped=true", function () {
      api.rerender('0d0ab7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scroll/CustomScroll.vue"
export default component.exports